import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';
import { printTockendataRequest } from "../../../../store/actions";
import { IKioskMessage, IKIOSKModel } from "../../../../models/kioskModel";
import leaf from '../../../../images/leaf.png';
import { getLabelConfigMsg, getTokenPrinttimeout, getTokenWhatsUrl } from "../../../../helpers/helpersIndex";
import QRCode from "react-qr-code";
import whatsapp from '../../../../images/whatsapp.svg';

import { Ilanguages } from "../../../../models/utilitiesModel";


let subscribe;

const TokenView: React.FC = () => {
    const { t } = useTranslation("translations");
    const dispatch = useDispatch();
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    let templateData: any = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.tokenData || undefined);
    let kioskPrintTime: number = useSelector((state) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.tokenPrintTimeout || getTokenPrinttimeout());
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
    
    const [printcount, setPrintCount] = useState(kioskPrintTime);
    useEffect(() => {
        if (templateData && printcount !== 0) {
            subscribe = setTimeout(() => {
                setPrintCount(printcount - 1);
            }, 1000);
        }
        return () => {
            clearTimeout(subscribe);
        }
    }, [printcount,kioskPrintTime,templateData]);
    console.log("tokenViewComponent==>", templateData,JSON.parse(templateData?.kioskTemplate));
    const printToken = () => {
        // downloadCode();
        if (templateData) {
            // let popupWin;
            // popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            // popupWin.document.open();
            // let barcodeHTML: any = document.getElementById('qrcodeTemplate')?.innerHTML;
            // let template = templateData?.tokenTemplate?.replace('{qrcode}', barcodeHTML);
            // console.log("PrintTemplateData==>", template);
            // popupWin.document.write(template);
            // popupWin.document.close();
            dispatch(printTockendataRequest(templateData?.kioskTemplate));
            setPrintCount(0)
        }
    }
    // const downloadCode = () => {
    //     const canvas: any = document.getElementById("qrcode");
    //     canvas.style.display = 'none';
    //     const image: any = document.getElementById("qrcodeimage");
    //     if (canvas) {
    //         const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image");
    //         image.src = pngUrl;
    //     }
    // }
    return (
        <div className='Kiosk_tokendisplay'>
            <h5>{(getLabelConfigMsg(kioskConfigMsgs,language,"tokenNo") || t("kiosktranslation.tokenNo" + language))}</h5>
            <h2>{templateData?.tokenNo}</h2>
            {/* <div id="qrcodeTemplate" style={{ display: "none" }} className="text-center">
                <QRCode
                    key={1}
                    value={JSON.stringify({ qrCodeString: templateData?.qrString })}
                    logoWidth={50}
                    logoHeight={50}
                    id="qrcode"
                />
                <img id="qrcodeimage" alt="qrcode" style={{ display: 'flex', margin: '0 auto' }}></img>
            </div> */}

            <div className='go_green'><img src={leaf} alt={t("kiosktranslation.leaf" + language)}></img>{(getLabelConfigMsg(kioskConfigMsgs,language,"commitedgreen") || t("kiosktranslation.commitedgreen" + language))}</div>

            <div className='token_text'>
                <span>{(getLabelConfigMsg(kioskConfigMsgs,language,"sendmessage") || t("kiosktranslation.sendmessage" + language))}</span>
                <button className="token-button mt-4" disabled={printcount === 0 ? true : false} onClick={printToken}>
                    <span>{(getLabelConfigMsg(kioskConfigMsgs,language,"printpaper") || t("kiosktranslation.printpaper" + language))}</span>
                    <div className='d-flex gap-3 align-items-center'><span className='token_number'>{printcount}</span><i className='icon_m42kiosk_token'></i></div>
                </button>
                <span className="w-100">{(getLabelConfigMsg(kioskConfigMsgs,language,"notify") || t("kiosktranslation.notify" + language))}</span>
                {getTokenWhatsUrl() && <div id="qrcodeTemplate" className="text-center">
                    <div>

                        <span>{(getLabelConfigMsg(kioskConfigMsgs,language,"scanQr") || t("kiosktranslation.scanQr" + language))} <br/> {(getLabelConfigMsg(kioskConfigMsgs,language,"continueWhatsapp") || t("kiosktranslation.continueWhatsapp" + language))}</span>

                        <img src={whatsapp} alt={t("kiosktranslation.whatsapplogo" + language)} width="50px"/>
                    </div>
                    <div>
                        <QRCode value={getTokenWhatsUrl()?.replace("{tokenNo}", templateData?.tokenNo)|| ''}/>
                    </div>
                    <span>{(getLabelConfigMsg(kioskConfigMsgs,language,"redirect") || t("kiosktranslation.redirect" + language))} <strong>{(getLabelConfigMsg(kioskConfigMsgs,language,"whatsApp") || t("kiosktranslation.whatsApp" + language))}</strong> <br/>{(getLabelConfigMsg(kioskConfigMsgs,language,"quickSecure") || t("kiosktranslation.quickSecure" + language))}</span>
                </div>}
            </div>
        </div>
    );
}
export default React.memo(TokenView);